import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IUpdateBillBeneficiaryRequest {
  id: string;
  customerId: string; //Phone Number if it's data, decoder number if DSTV
  billerName: string;
  billCategory: string;
  billerId: string;
  billItemId: string;
  alias: string;
}

interface IUpdateBillBeneficiaryResponse {
  status?: boolean;
  message?: string;
  data?: unknown;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IUpdateBillBeneficiaryResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const updateBillBeneficiaryAsync = createAsyncThunk(
  'updateBillBeneficiary',
  async (
    values: IUpdateBillBeneficiaryRequest,
    { rejectWithValue, getState }
  ) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
        },
      };

      const { data } = await api.put(
        `/billpayment/beneficiaries/update/${values.id}`,
        {
          customerId: values.customerId,
          billerName: values.billerName,
          billCategory: values.billCategory,
          billerId: values.billerId,
          billItemId: values.billItemId,
          alias: values.alias,
        },
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IUpdateBillBeneficiaryResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const billBeneficiaryUpdateSlice = createSlice({
  name: 'updateBillBeneficiary',
  initialState,
  reducers: {
    resetBillBeneficiaryUpdate(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateBillBeneficiaryAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(updateBillBeneficiaryAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IUpdateBillBeneficiaryResponse;
      })
      .addCase(updateBillBeneficiaryAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IUpdateBillBeneficiaryResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetBillBeneficiaryUpdate } =
  billBeneficiaryUpdateSlice.actions;

export default billBeneficiaryUpdateSlice.reducer;
